export interface ComputedResult {
  total: number;
  available: number;
}
